import axios from "axios";
import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ProjectConfig } from "Global";
import { CircularProgress } from "@mui/material";

export default function OracionesEditorRedirect() {
  const { oracion_id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Obtener los detalles de la oración para saber su categoría
    axios
      .get(ProjectConfig.api_url, {
        params: {
          request: "oraciones_details",
          id: oracion_id,
        },
      })
      .then((response) => {
        const oraciones_category_id = response.data.oraciones_category_id || 1;
        // Redirigir a la URL correcta con la categoría
        navigate(`/admin/oraciones/${oraciones_category_id}/edit/${oracion_id}`, { replace: true });
      })
      .catch((err) => {
        console.log(err);
        // Si hay error, redirigir a la lista de categorías
        navigate("/admin/oraciones/categorias");
      });
  }, [oracion_id, navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <CircularProgress />
    </div>
  );
}
